import { ExternalLink, Award, GraduationCap } from "lucide-react";
import { Reveal } from "./Reveal";
import { CERTS, EDUCATION } from "../../data/content";

export const Credentials = () => (
  <section id="certifications" data-testid="certifications-section" className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-40">
    <Reveal className="max-w-3xl">
      <p className="overline text-terracotta">Credentials</p>
      <h2 className="mt-6 font-serif text-5xl md:text-7xl tracking-tight leading-[0.95] text-ink">
        Certified,
        <br />
        and always learning.
      </h2>
    </Reveal>

    <div className="mt-14 md:mt-20 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
      <Reveal>
        <div className="flex items-center gap-3 mb-6">
          <Award size={18} className="text-terracotta" />
          <p className="overline text-stone">Certifications</p>
        </div>
        <ul className="space-y-4">
          {CERTS.map((c) => (
            <li key={c.title}>
              <a
                href={c.file}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`cert-link-${c.title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "").split("-").slice(0, 2).join("-")}`}
                className="group flex items-start justify-between gap-3 font-serif text-xl md:text-2xl text-ink leading-tight border-l-2 border-terracotta pl-4 hover:text-terracotta transition-colors duration-300"
              >
                <span>{c.title}</span>
                <ExternalLink
                  size={16}
                  className="mt-1.5 shrink-0 text-stone group-hover:text-terracotta group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300"
                />
              </a>
            </li>
          ))}
        </ul>
        <p className="mt-4 pl-4 text-xs uppercase tracking-[0.14em] text-stone">Tap to view certificate</p>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="flex items-center gap-3 mb-6">
          <GraduationCap size={18} className="text-sage" />
          <p className="overline text-stone">Education</p>
        </div>
        <ul className="space-y-4">
          {EDUCATION.map((c) => (
            <li key={c} className="text-base md:text-lg text-stone leading-relaxed border-l-2 border-sage pl-4">
              {c}
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
